import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppUrlConstant } from '../../../constant/app-url';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TopPanelBtnConfiguration } from './top-panel';

@Component({
    selector: 'app-top-panel',
    templateUrl: './top-panel.component.html',
    styleUrl: './top-panel.component.scss',
    providers: [NgbModal],
})
export class TopPanelComponent {
    @Input() topPanelConfiguration!: TopPanelBtnConfiguration;
    @Output() onBtnClick = new EventEmitter<string>();
    @Output() modalStateChanged = new EventEmitter<boolean>();

    appUrlConstant = AppUrlConstant;

    constructor() {}
}
